<div class='outer'>
  <div class='left'>
  </div>
  <div class='right'>
    <div class='box'>
      <div class='character-or-pattern'></div>
      <button (click)="gotoLessonPlansPage()">Lesson Plans</button>
    </div>
    <div class='box'>
      <div class='character-or-pattern'></div>
      <button (click)="gotoResourcesPage()">Resources</button>
    </div>
  </div>
</div>
  